import * as React from 'react'
import styled from 'styled-components'
import { colors, devices } from '../../styleConstants'

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  subHeading?: string
}

export default function Heading({ subHeading, children, ...props }: Props) {
  return (
    <Root {...props}>
      <Text>{children}</Text>
      {subHeading && <Sub>{subHeading}</Sub>}
    </Root>
  )
}

const Root = styled.h2`
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding-bottom: 14px;
  align-items: flex-end;
  border-bottom: 1px solid ${colors.secondaryDark};
  font-size: 24px;
  font-weight: normal;
  line-height: 36px;
  color: ${colors.secondaryDark};

  @media ${devices.mobile} {
    display: block;
    padding-bottom: 0;
    border: none;
  }
`

const Text = styled.span`
  display: block;

  @media ${devices.mobile} {
    padding-bottom: 10px;
    border-bottom: 1px solid ${colors.secondaryDark};
  }
`

const Sub = styled.span`
  display: block;
  font-size: 16px;
  font-weight: normal;
  line-height: 30px;

  @media ${devices.mobile} {
    padding-top: 6px;
    text-align: right;
  }
`
